import React,  { Component } from 'react';
import { Redirect } from 'react-router-dom';

import {Button} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { ValidationForm, TextInput } from "react-bootstrap4-form-validation"
import {Event} from '../Analytics';

import LetterIdentifications from '../../artifacts/LetterIdentifications.svg';

const AccessCode = () => (
  <AccessCodeForm />
  );

class AccessCodeClass extends Component {
	constructor(props) {
		super(props);
		 this.state = {
	      validated:  false,
	      setValidated : false,
	      submit : false,
	      accesscode: "",
	      groupnumber:"",
	      valid:false,
	      client: null,
	      ...props
	    };
	};


	isValid = () => {

		let regex = /[0-9]{6}/;
		if(regex.test(this.state.accesscode)) {
			this.setState({submit : true});
			return true;
		} else {
			return false;
		}

	};

	submitHandler = event => {
		event.preventDefault();
		this.setState({submit : true});

		var apiUrl = process.env.REACT_APP_CLIENT_LOOKUP_URL;
		if (apiUrl) {
			fetch(apiUrl + '/' + this.state.accesscode)
				.then(function(response) { return response.json(); })
				.then(function(data) {
					if (data && data.client) {
						this.setState({client: data.client, valid: true});
					} else {
						this.setState({valid: true});
					}
				}.bind(this))
				.catch(function() {
					this.setState({valid: true});
				}.bind(this));
		} else {
			this.setState({valid: true});
		}
	};

	changeHandler = event => {
		this.setState({ [event.target.name]: event.target.value });

	};


	


	render() {
		const {accesscode, submit, valid, client} = this.state;

		if(valid) {
			var path;
			if (client) {
				path = "/c/" + client + "/upload/" + accesscode;
			} else {
				path = "/upload/" + accesscode;
			}
			Event("ACCESSCODE", "Access Code submitted", "ACCESSCODE");
			return <Redirect to={path} />
		}

		let submitbutton;
		if(submit) {
			submitbutton = <FontAwesomeIcon icon={faSpinner} spin />;
		} else {
			submitbutton = "Submit";
		}



		return (
			<div className="card-dark">
				<p style={{ marginBottom: 'var(--space-4, 1rem)', textAlign: 'center' }}>The Access Code is located in the lower, right corner of the letter we sent you.</p>

				<div style={{ display: 'flex', justifyContent: 'center', marginBottom: 'var(--space-6, 1.5rem)' }}>
					<img className="img-rounded" src={LetterIdentifications} alt="Letter Layout" style={{ maxWidth: '100%', height: 'auto' }}/>
				</div>

				<ValidationForm onSubmit={this.submitHandler}>
					<div style={{ maxWidth: '400px', margin: '0 auto' }}>
						<div className="form-group" style={{ marginBottom: 'var(--space-4, 1rem)' }}>
							<label htmlFor="accesscode">Access Code</label>
							<TextInput
								name="accesscode"
								id="accesscode"
								onChange={this.changeHandler}
								placeholder="Enter Access Code Here"
								required
								pattern='[0-9]+'
								maxLength="6"
								errorMessage={{
									required: "Please enter a valid Access Code.",
									pattern: "Please enter a valid Access Code.",
									maxLength: "Please enter a valid Access Code."
								}}
							/>
						</div>
						<div style={{ textAlign: 'center' }}>
							<Button variant="primary" type="submit">
								{submitbutton}
							</Button>
						</div>
					</div>
				</ValidationForm>
			</div>
		);

	}
}

const AccessCodeForm = AccessCodeClass;

export default AccessCode;